export interface EditFacilityFormData {
  name: string;
  nip: string;
  phoneNumber: string;
  countryCode: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
}

export interface EditFacilityFormErrors {
  name?: string;
  nip?: string;
  phoneNumber?: string;
  countryCode?: string;
  addressLine1?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  country?: string;
  general?: string;
}

export type EditFacilityPatchPayload = Partial<EditFacilityFormData>;

export const INITIAL_EDIT_FACILITY_FORM_DATA: EditFacilityFormData = {
  name: '',
  nip: '',
  phoneNumber: '',
  countryCode: '',
  addressLine1: '',
  addressLine2: '',
  city: '',
  state: '',
  zipCode: '',
  country: '',
};

// Must match FACILITY_MANDATORY_FIELDS in pozytron-backend/lib/types/facility.ts
export const EDIT_FACILITY_MANDATORY_FIELDS: (keyof EditFacilityFormData)[] = [
  'name',
  'nip',
  'phoneNumber',
  'countryCode',
  'addressLine1',
  'city',
  'state',
  'country',
];
